import { Sounds } from '@/engage/types/sounds'

export default Object.freeze({
  NEW_TICKET: Sounds.NEW_TICKET,
  NEW_MESSAGE: Sounds.NEW_MESSAGE,
})
